export default {
  forgot_password_confirm: {
    title: 'รีเซ็ตรหัสผ่าน',
    required_code: 'จำเป็นต้องใช้รหัส',
    required_password: 'จำเป็นต้องใช้รหัสผ่าน',
    max_length_16: 'รหัสผ่านต้องมีอักขระ 8-16 ตัว',
    // no_blank: "",
    no_password_match: 'รหัสผ่านไม่ตรงกัน',
    reset_password: 'รีเซ็ตรหัสผ่าน',
    caution: 'กรุณาอย่าเพิ่งปิดหน้าต่างนี้',
    double_check_text: '@:login.double_check_text',
    password_reset_text: 'ระบบได้ส่งอีเมลไปยังที่อยู่อีเมลนั้นแล้ว กรุณากรอกรหัสยืนยันที่ส่งไปยังอีเมลของคุณด้านล่าง',
    verification_code: 'รหัสยืนยัน',
    mail_send_code: 'รหัสที่ส่งไปในอีเมล์',
    password: 'รหัสผ่าน',
    new_password: 'รหัสผ่านใหม่',
    password_display: 'แสดงรหัสผ่าน',
    password_no_display: 'ซ่อนรหัสผ่าน',
    password_check: 'ยืนยันรหัสผ่าน',
    submit: 'ยืนยัน',
  },
}
